"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

const [LEFT, RIGHT] = ['left', 'right'];

const QuickSeek = ({
  videoTag,
  skipSize
}) => {
  const leftQuickSeekRef = (0, _react.useRef)(null);
  const rightQuickSeekRef = (0, _react.useRef)(null);
  const [isLeftAnimation, setLeftAnimation] = (0, _react.useState)(false);
  const [isRightAnimation, setRightAnimation] = (0, _react.useState)(false);

  function onSeek(e, direction) {
    e.stopPropagation();
    let ref;

    switch (direction) {
      case LEFT:
        videoTag.currentTime -= skipSize;
        ref = leftQuickSeekRef;
        setLeftAnimation(true);
        break;

      case RIGHT:
        videoTag.currentTime += skipSize;
        ref = rightQuickSeekRef;
        setRightAnimation(true);
        break;

      default:
        break;
    }

    ref.current.addEventListener('webkitAnimationEnd', () => onQuickSeekAnimationEnd(direction)); // webkit for Chrome, Safari and Opera

    ref.current.addEventListener('animationend', () => onQuickSeekAnimationEnd(direction));
  }

  function onQuickSeekAnimationEnd(direction) {
    direction === LEFT ? setLeftAnimation(false) : setRightAnimation(false);
  }

  function renderSeek(direction, ref) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)("quick-seek__".concat(direction), {
        'quick-seek--animation': direction === LEFT ? isLeftAnimation : isRightAnimation
      }),
      onDoubleClick: e => onSeek(e, direction),
      ref: ref
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "quick-seek__arrows"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "quick-seek__arrow"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "quick-seek__arrow"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "quick-seek__arrow"
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "quick-seek__text"
    }, "".concat(skipSize, " seconds")));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-seek"
  }, renderSeek(LEFT, leftQuickSeekRef), renderSeek(RIGHT, rightQuickSeekRef));
};

QuickSeek.propTypes = {
  videoTag: _propTypes.default.shape({
    currentTime: _propTypes.default.number
  }),
  skipSize: _propTypes.default.number
};
QuickSeek.defaultProps = {
  videoTag: null,
  skipSize: 5
};
var _default = QuickSeek;
exports.default = _default;